/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkTutorImportSummaryResponse } from "../models/BulkTutorImportSummaryResponse";
import type { Body_bulk_import_tutors } from "../models/Body_bulk_import_tutors";
import type { Body_bulk_import_meetings } from "../models/Body_bulk_import_meetings";
import type { Body_bulk_import_students_parents } from "../models/Body_bulk_import_students_parents";
import type { BulkImportSummaryResponse } from "../models/BulkImportSummaryResponse";
import type { BulkMeetingImportSummaryResponse } from "../models/BulkMeetingImportSummaryResponse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class ImportsService {
  /**
   * Bulk Import Students Parents
   * Import up to a few thousand student / parent rows
   * in one transaction. See the template in the docs
   * for the required column order.
   * @returns BulkImportSummaryResponse Successful Response
   * @throws ApiError
   */
  public static bulkImportStudentsParents({
    orgId,
    formData,
  }: {
    orgId: number;
    formData: Body_bulk_import_students_parents;
  }): CancelablePromise<BulkImportSummaryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/imports/bulk_import/{org_id}",
      path: {
        org_id: orgId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Bulk Import Meetings
   * Import meetings from a CSV/XLSX spreadsheet.
   * @returns BulkMeetingImportSummaryResponse Successful Response
   * @throws ApiError
   */
  public static bulkImportMeetings({
    orgId,
    formData,
  }: {
    orgId: number;
    formData: Body_bulk_import_meetings;
  }): CancelablePromise<BulkMeetingImportSummaryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/imports/bulk_import_meetings/{org_id}",
      path: {
        org_id: orgId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Bulk Import Tutors
   * Fill tutor CRM fields from a CSV/XLSX sheet in one transaction. Tutors
   * are matched by email, then by name; rows that match no tutor are listed
   * in the answer and nothing is created for them.
   * @returns BulkTutorImportSummaryResponse Successful Response
   * @throws ApiError
   */
  public static bulkImportTutors({
    orgId,
    formData,
  }: {
    orgId: number;
    formData: Body_bulk_import_tutors;
  }): CancelablePromise<BulkTutorImportSummaryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/imports/bulk_import_tutors/{org_id}",
      path: {
        org_id: orgId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
